import { gql } from "@outschool/ui-apollo";

const MagnetPageItemsFragment = gql`
  fragment MagnetPageItems on ContentfulMagnetPage {
    magnetPageSlug
    categoryLabel {
      value
    }
    title
    author {
      name
      profileImage {
        url
      }
    }
    headerImage {
      url(transform: { quality: 85, width: 692, height: 302, format: JPG })
    }
  }
`;

export const ArticlesBySlugQuery = gql`
  query getArticlesBySlug($categoryLabel: String!) {
    contentfulMagnetPageCollection(
      where: { categoryLabel: { value: $categoryLabel } }
    ) {
      items {
        ...MagnetPageItems
      }
    }
  }
  ${MagnetPageItemsFragment}
`;

export const ArticlesByIdQuery = gql`
  query getArticlesById($id: String!) {
    contentfulFeaturedPagesCollection(limit: 1, skip: 0, where: { id: $id }) {
      items {
        pagesCollection {
          items {
            ...MagnetPageItems
          }
        }
      }
    }
  }
  ${MagnetPageItemsFragment}
`;
